import $ from 'jquery'

const hash = window.location.hash.substring(1);

$(".projects_card").on("click", (e) => {
    //e.delegateTarget.dataset.id
    $(`#${e.delegateTarget.dataset.id}`).show()
})

$(".close_modal").on("click", (e) => {
    $(`#${e.delegateTarget.dataset.id}`).hide()
})

$(`[data-slug=${hash}]`).trigger('click');
